function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M132.89 232.56c-27.48,0 -49.83,22.35 -49.83,49.83 0,27.48 22.35,49.83 49.83,49.83 27.48,0 49.83,-22.35 49.83,-49.83 0,-27.48 -22.35,-49.83 -49.83,-49.83zm0 110.74c-33.58,0 -60.91,-27.33 -60.91,-60.91 0,-33.58 27.33,-60.91 60.91,-60.91 33.58,0 60.91,27.33 60.91,60.91 0,33.58 -27.33,60.91 -60.91,60.91z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "188.26,271.32 232.56,271.32 232.56,260.24 188.26,260.24 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "188.26,304.54 232.56,304.54 232.56,293.46 188.26,293.46 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M343.3 282.39l-11.07 0 0 -105.21 -68.91 0 -25.22 40.35 0 42.71 -11.08 0 0 -45.88 30.15 -48.25 75.06 0c6.1,0 11.07,4.97 11.07,11.07l0 105.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M121.76 227.81l-10.96 -1.58 10.39 -72.76c0.77,-5.42 5.49,-9.51 10.96,-9.51l22.89 0 0 83.06 -11.08 0 0 -71.98 -11.81 0 -10.39 72.77z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "77.52,193.8 121.82,193.8 121.82,182.72 77.52,182.72 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "77.52,215.95 121.82,215.95 121.82,204.87 77.52,204.87 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M138.43 11.07l0 11.08 177.2 0 -0.02 -11.08 -177.18 0zm177.18 22.15l-177.18 0c-6.11,0 -11.08,-4.96 -11.08,-11.07l0 -11.08c0,-6.1 4.97,-11.07 11.08,-11.07l177.18 0c6.11,0 11.08,4.97 11.08,11.07l0 11.08c0,6.11 -4.97,11.07 -11.08,11.07z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "310.11,172.28 293.5,28.32 304.5,27.05 321.11,171.02 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "287.97,172.28 271.36,28.32 282.35,27.05 298.96,171.02 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "146.48,150.13 135.49,148.87 149.54,27.05 160.54,28.32 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "168.63,150.13 157.63,148.87 171.69,27.05 182.69,28.32 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "149.5,155.04 287.93,155.04 287.93,143.96 149.5,143.96 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "149.5,177.18 238.1,177.18 238.1,166.11 149.5,166.11 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "199.34,199.34 221.48,199.34 221.48,188.26 199.34,188.26 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M337.76 210.41l-55.37 0c-9.16,0 -16.61,-7.45 -16.61,-16.61l0 -22.15 11.07 0 0 22.15c0,3.05 2.49,5.54 5.54,5.54l55.37 0 0 11.07z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "287.93,204.87 299,204.87 299,171.65 287.93,171.65 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "310.08,204.87 321.15,204.87 321.15,171.65 310.08,171.65 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "27.11,318.09 17.19,313.14 44.3,258.94 44.3,193.8 55.37,193.8 55.37,261.55 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M11.07 310.08l35.34 0 25.57 -51.14 0 -87.29 -16.61 0 0 11.07 -11.07 0 0 -24.26 -22.15 -11.07 0 0.8 11.07 22.15 0 69.06 -22.15 44.3 0 26.38zm42.19 11.07l-53.26 0 0 -40.07 22.15 -44.29 0 -63.83 -11.08 -22.15 0 -21.34 44.3 22.15 0 8.95 27.69 0 0 100.98 -29.8 59.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M197.89 121.82l58.26 0 -6.47 -66.45 -45.32 0 -6.47 66.45zm70.47 11.07l-82.68 0 8.63 -88.59 65.42 0 8.63 88.59z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "199.34,88.59 254.71,88.59 254.71,77.52 199.34,77.52 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "210.41,110.74 232.56,110.74 232.56,99.67 210.41,99.67 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M282.39 232.56c-27.48,0 -49.83,22.35 -49.83,49.83 0,27.48 22.35,49.83 49.83,49.83 27.48,0 49.84,-22.35 49.84,-49.83 0,-27.48 -22.36,-49.83 -49.84,-49.83zm0 110.74c-33.58,0 -60.91,-27.33 -60.91,-60.91 0,-33.58 27.33,-60.91 60.91,-60.91 33.58,0 60.91,27.33 60.91,60.91 0,33.58 -27.33,60.91 -60.91,60.91z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M132.89 265.78c-9.16,0 -16.61,7.45 -16.61,16.61 0,9.16 7.45,16.61 16.61,16.61 9.16,0 16.61,-7.45 16.61,-16.61 0,-9.16 -7.45,-16.61 -16.61,-16.61zm0 44.3c-15.26,0 -27.69,-12.42 -27.69,-27.69 0,-15.27 12.43,-27.69 27.69,-27.69 15.27,0 27.69,12.42 27.69,27.69 0,15.27 -12.42,27.69 -27.69,27.69z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M282.39 265.78c-9.16,0 -16.61,7.45 -16.61,16.61 0,9.16 7.45,16.61 16.61,16.61 9.16,0 16.61,-7.45 16.61,-16.61 0,-9.16 -7.45,-16.61 -16.61,-16.61zm0 44.3c-15.26,0 -27.68,-12.42 -27.68,-27.69 0,-15.27 12.42,-27.69 27.68,-27.69 15.27,0 27.69,12.42 27.69,27.69 0,15.27 -12.42,27.69 -27.69,27.69z"
}));

var SvgBulldozerWheels = function SvgBulldozerWheels(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "338px",
    height: "338px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 343.3 343.3",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBulldozerWheels, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bulldozerWheels.0334b819.svg";
export { ForwardRef as ReactComponent };